import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import type { MatrixListItemUi } from "@/domains/matrix";
import { DeleteMatrixDialog } from "./delete-matrix-dialog";
import { RenameMatrixDialog } from "./rename-matrix-dialog";
import { extractErrorMessage } from "../lib/extract-error-message";

type MatrixTarget = { collectionId: string; name: string };

type MatrixRowActionDialogsProps = {
  matrices: MatrixListItemUi[];
  activeCollectionId: string | null;
  pendingRename: MatrixTarget | null;
  pendingDelete: MatrixTarget | null;
  duplicateError: unknown;
  onCloseRename: () => void;
  onCloseDelete: () => void;
  onDismissDuplicateError: () => void;
};

/**
 * Everything `useMatrixRowActions` needs on screen, rendered beside a list
 * rather than inside the menu that opened it. Duplicating asks nothing before
 * it runs, so its failure needs a surface of its own.
 */
export function MatrixRowActionDialogs({
  matrices,
  activeCollectionId,
  pendingRename,
  pendingDelete,
  duplicateError,
  onCloseRename,
  onCloseDelete,
  onDismissDuplicateError,
}: MatrixRowActionDialogsProps) {
  return (
    <>
      <RenameMatrixDialog target={pendingRename} onClose={onCloseRename} />
      <DeleteMatrixDialog
        target={pendingDelete}
        matrices={matrices}
        activeCollectionId={activeCollectionId}
        onClose={onCloseDelete}
      />
      <Dialog
        open={Boolean(duplicateError)}
        onOpenChange={(open) => {
          if (!open) onDismissDuplicateError();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Could not duplicate the matrix</DialogTitle>
            <DialogDescription>
              {extractErrorMessage(
                duplicateError,
                "Failed to duplicate the matrix. Please try again.",
              )}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={onDismissDuplicateError}>Close</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
